var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_c('source',{attrs:{"srcset":_vm.srcset}}),_c('img',{class:_vm.imgClass,attrs:{"loading":"lazy","src":_vm.imgSrc,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }